'use strict';

var _reactTransformCatchErrors2 = require('react-transform-catch-errors');

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

var _reactTransformCatchErrors3 = _interopRequireDefault(_reactTransformCatchErrors2);

var _react = require('react');

var _redboxReact = require('redbox-react');

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

exports.__esModule = true;

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _components2 = require('components');

var _components = {
  _$Home: {
    displayName: 'Home'
  }
};

var _reactComponentWrapper = _reactTransformCatchErrors3['default']({
  filename: '/var/www/websites/blog.paymentwall.com/releases/20220825105928/src/containers/Home/Home.js',
  components: _components,
  locals: [],
  imports: [_react, _redboxReact]
});

var _reactComponentWrapper2 = _reactTransformCatchErrors3['default']({
  filename: '/var/www/websites/blog.paymentwall.com/releases/20220825105928/src/containers/Home/Home.js',
  components: _components,
  locals: [],
  imports: [_react, _redboxReact]
});

function _wrapComponent(uniqueId) {
  return function (ReactClass) {
    return _reactComponentWrapper2(_reactComponentWrapper(ReactClass, uniqueId), uniqueId);
  };
}

var Home = (function (_Component) {
  _inherits(Home, _Component);

  function Home() {
    _classCallCheck(this, _Home);

    _Component.apply(this, arguments);
  }

  Home.prototype.render = function render() {
    return _react2['default'].createElement(
      'div',
      null,
      _react2['default'].createElement(_reactHelmet2['default'], { title: 'Global Tech and Finance News' }),
      _react2['default'].createElement(
        'section',
        { className: 'page-hero' },
        _react2['default'].createElement(_components2.PostSticky, null)
      ),
      _react2['default'].createElement(
        'section',
        { className: 'page-content' },
        _react2['default'].createElement(_components2.PostList, null)
      )
    );
  };

  var _Home = Home;
  Home = _wrapComponent('_$Home')(Home) || Home;
  return Home;
})(_react.Component);

exports['default'] = Home;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Home/Home.js
// module id = 675
// module chunks = 0